<template>
<transition name="fade" mode="out-in" appear>
    <component :is="urlQuery"></component>
</transition>
</template>


<script>
import axios from "axios"
import Dashboard from '../views/DynamicFormModule/Dashboard'
import DocumentSetup from '../views/DynamicFormModule/DocumentSetup/DocumentSetup'
import DocumentOnDemand from '../views/DynamicFormModule/DocumentOnDemand/DocumentOnDemand'
import FillOutDocument from '../views/DynamicFormModule/DocumentOnDemand/FillOutDocument'
import DocumentFilledByTeam from '../views/DynamicFormModule/DocumentFilledByTeam/DocumentFilledByTeam'
import DocumentFilledByPersonal from '../views/DynamicFormModule/DocumentFilledByPersonal/DocumentFilledByPersonal'
import PersonalPreview from '../views/DynamicFormModule/DocumentFilledByPersonal/PreviewDocumentPersonal'

export default {
    name: 'DynamicForm',
    components: {
        Dashboard,
        DocumentSetup,
        DocumentOnDemand,
        FillOutDocument,
        DocumentFilledByTeam,
        DocumentFilledByPersonal,
        PersonalPreview,
    },
    async created() {
        try {
            await this.$store.dispatch('setLoading', true);
            const resp = await axios.get("user-service/auth/menu?module=dynamic_form", {
                headers: {
                    Authorization: localStorage.getItem("token") || "",
                },
            });
            if (resp.data.error === false) {
                this.listApplication = resp.data.data;
                await this.$store.dispatch('setMenu', resp.data.data);
                return;
            }
        } catch (error) {
            if (error.response != undefined) {
                if (error.response.data != undefined) {
                    if (error.response.data.error_auth != undefined) {
                        this.$swal.fire("Get Application List", error.response.data.message, "error");
                        this.$store.dispatch("logOut").then(() => {
                            this.$router.push("/login");
                        });
                        return;
                    }
                    return this.$swal.fire("Get Application List ", error.response.data.message, "error");
                }
            }

            this.$sentry.captureException(error);
            this.$swal.fire("Error", error.message, "error");
        } finally {
            this.$store.dispatch("setApp");
            this.$store.dispatch('setLoading', false);
        }
    },
    computed: {
        urlQuery() {
            return this.$route.params.component || 'Dashboard';
        }
    }
}
</script>